import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes2';
import { Dimmer } from '../components/spinner';
import useTable from '../components/useTable';
import axios from "axios";

const CatalogoConceptosNomina = props => {
    let op = require('../modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [selectedConcepto, setSelectedConcepto] = useState(null);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });

    const headCells = [
        { id: "codconcep", label: 'CÓDIGO', textAlign: 'center' },
        { id: "nomconcep", label: 'NOMBRE DEL CONCEPTO', textAlign: 'left' },
    ];

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => 
                        x.codconcep?.toString().toLowerCase().includes(target.value.toLowerCase()) ||
                        x.nomconcep?.toLowerCase().includes(target.value.toLowerCase())
                    );
                }
            }
        });
    };

    const cargarConceptos = () => {
        let codigoNomina = localStorage.getItem('codigonomina');
        codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';
        
        const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=codconcep, nomconcep&nomtab=nomi${codigoNomina}.conceptos&condi=1=1&orden=codconcep`;
        
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data && response.data.length > 0) {
                    setRecords(response.data);
                } else {
                    setRecords([]);
                    setMensaje({ mostrar: true, titulo: 'Información', texto: 'No hay conceptos disponibles', icono: 'info' });
                }
            }
        }).catch(function (error) {
            console.error('Error al cargar conceptos:', error);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response?.data?.message || 'Error al cargar los conceptos', icono: 'error' });
        }).finally(() => {
            setActivate(false);
        });
    };

    const blanquear = () => {
        setSelectedConcepto(null);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    };

    const cancelar = () => {
        props.onHideCancelar();
        blanquear();
    };

    const seleccionarConcepto = () => {
        if (selectedConcepto) {
            props.onHideAceptaCatalogo(selectedConcepto);
        } else {
            setMensaje({ mostrar: true, titulo: 'Advertencia', texto: 'Debe seleccionar un concepto', icono: 'warning' });
        }
    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        setSelectedConcepto({
            codconcep: item.codconcep,
            nomconcep: item.nomconcep
        });
        btnAcepta.current.focus();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                cargarConceptos();
            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light">
                    <h3 className="m-0">Seleccionar Concepto de Nómina</h3>
                </div>
                <button 
                    ref={btnCancela} 
                    className="bg-transparent" 
                    style={{ border: 0, margin: 0, padding: 0, color: "#ffffff", fontSize: "1.5rem" }} 
                    onClick={cancelar}
                >
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted />
                
                <div className="col-md-12 m-0 mb-3">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text bg-white">
                            <i className="fas fa-search"></i>
                        </span>
                        <input 
                            type='text'
                            onChange={handleSearch} 
                            className="form-control" 
                            placeholder="Buscar por código o nombre del concepto..."
                        />
                    </div>
                </div>
                
                <div className="col-md-12" style={{ margin: "auto", maxHeight: "400px", overflowY: "auto" }}>
                    <TblContainer>
                        <TblHead />
                        <tbody>
                            {records && recordsAfterPagingAndSorting().length > 0 ? (
                                recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr 
                                        key={index} 
                                        style={{ 
                                            padding: "0", 
                                            cursor: 'pointer', 
                                            background: selectedConcepto?.codconcep === item.codconcep ? "#e3f2fd" : "white",
                                            transition: "background 0.2s"
                                        }} 
                                        onClick={seleccionarFila(item)}
                                        onMouseEnter={(e) => {
                                            if (selectedConcepto?.codconcep !== item.codconcep) {
                                                e.currentTarget.style.backgroundColor = "#f5f5f5";
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (selectedConcepto?.codconcep !== item.codconcep) {
                                                e.currentTarget.style.backgroundColor = "white";
                                            }
                                        }}
                                    >
                                        <td className='py-2 text-center' style={{ fontWeight: "bold" }}>{item.codconcep}</td>
                                        <td className='py-2'>{item.nomconcep}</td>
                                    </tr>
                                ))
                            ) : (
                                !activate && (
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "center", padding: "40px", color: "#999" }}>
                                            <i className="fas fa-inbox fa-3x mb-2"></i>
                                            <p className="mb-0">No hay conceptos disponibles</p>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </TblContainer>
                    {records && records.length > 0 && <TblPagination />}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button 
                    ref={btnAcepta} 
                    className="btn btn-sm btn-success rounded-pill px-4" 
                    onClick={seleccionarConcepto}
                >
                    <i className="fas fa-check-circle me-2"></i> Aceptar
                </button>
                <button 
                    ref={btnCancela} 
                    onClick={cancelar} 
                    className="btn btn-sm btn-danger rounded-pill px-4"
                >
                    <i className="fas fa-times-circle me-2"></i> Cancelar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default CatalogoConceptosNomina;